export default __webpack_public_path__ + "static/media/no-image-search.fd743e1c.png";